import * as React from 'react';
import Button from '@material-ui/core/Button';
import {
  Dialog, DialogActions, DialogContent, DialogTitle,
  TextField, Typography, CircularProgress,
} from '@material-ui/core';
import type { IMissingInformationDialogProps } from './EstimatorInterfaces';

const MissingInformationDialog: React.FC<IMissingInformationDialogProps> = (
  {
    repairId, barcode, showModal, onClose, isFetching,
  },
) => {
  const [details, setDetails] = React.useState<string>('');

  const handleClose = () => {
    setDetails('');
    onClose(repairId);
  };

  const handleSave = () => {
    // YOU DO NOTHING
    onClose(repairId, details);
  };

  const handleDetailsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDetails(event.target.value);
  };

  return (
    <Dialog onClose={handleClose} open={showModal}>
      <DialogTitle>
        <Typography variant="overline">{`CURRENT BARCODE · #${barcode}`}</Typography>
        <Typography gutterBottom variant="h5" id="dialog-header">{'Current Repair is missing information.'}</Typography>
        <Typography variant="body2" color="textSecondary">
          {'Provide more information on the missing information from this repair item.'}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <TextField size="small" fullWidth label="Details" variant="outlined" value={details} onChange={handleDetailsChange} />
      </DialogContent>
      <DialogActions>
        <Button id="cancel-missing-info-modal-button" color="secondary" variant="text" onClick={handleClose}>{'CANCEL'}</Button>
        <Button id="send-to-customer-service-button" color="primary" variant="contained" disabled={!(details && details.length > 0 && !isFetching)} onClick={handleSave}>
          {isFetching ? <CircularProgress size={25} /> : 'SEND TO CUSTOMER SERVICE'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MissingInformationDialog;
